import React, { Component } from 'react';
import documentData from '../../constants/documentType.json'
import Document from '../shared/document/Document';
import PageInfo from '../shared/pageInfo/PageInfo';

class StepByStep extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        const stepIcon = process.env.BASE_URL + "images/app/stepByStep.png";
        var stepByStepData = documentData.filter(document => document.folderName == "StepByStep")[0];
        var documents = stepByStepData.files.map(file => {
            return <Document DocName={file.name} key={file.id} path={file.path} type={file.downloadType} />
        })
        return (
            <div className="mainBoxContent">
                <PageInfo pageTitle={stepByStepData.title} pageContent={stepByStepData.content} imgIcon={stepIcon} />
                <div className="docContainer">
                    {documents}
                </div>
            </div >
        )
    }
}

export default StepByStep;